import styled from 'styled-components';

export const Wrapper = styled.footer`
  margin-top: 96px;
  background: var(--night);
  color: var(--on-night);
  overflow: hidden;
`;

export const Marquee = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: var(--maxWidth);
  margin: 0 auto;
  padding: 28px var(--gutter) 0;
  font-family: var(--font-display);
  font-style: italic;
  font-weight: 400;
  font-size: clamp(14px, 2.2vw, 30px);
  color: rgba(246, 241, 232, 0.16);

  span:first-child,
  span:last-child {
    color: var(--accent);
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 40px;
  max-width: var(--maxWidth);
  margin: 0 auto;
  padding: 40px var(--gutter);

  p {
    max-width: 460px;
    color: var(--on-night-muted);
    font-size: 15px;

    em {
      font-family: var(--font-display);
      color: var(--on-night);
    }
  }

  .tmdb img {
    width: 110px;
    opacity: 0.85;
    transition: opacity 0.2s;
  }

  .tmdb:hover img {
    opacity: 1;
  }

  @media (max-width: 820px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const Bottom = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px 24px;
  max-width: var(--maxWidth);
  margin: 0 auto;
  padding: 20px var(--gutter) 32px;
  border-top: 1px solid rgba(246, 241, 232, 0.1);
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.04em;
  color: var(--on-night-muted);
`;

export const Credit = styled.a`
  display: inline-flex;
  align-items: baseline;
  gap: 8px;
  color: var(--on-night-muted);
  transition: color 0.25s var(--ease);

  .label {
    text-transform: uppercase;
    letter-spacing: 0.12em;
  }

  .name {
    position: relative;
    font-family: var(--font-display);
    font-style: italic;
    font-size: 15px;
    letter-spacing: 0;
    color: var(--on-night);

    &::after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: -2px;
      height: 1px;
      background: var(--accent);
      transform: scaleX(0.25);
      transform-origin: left;
      transition: transform 0.35s var(--ease);
    }
  }

  .arrow {
    color: var(--accent);
    transition: transform 0.25s var(--ease);
  }

  &:hover,
  &:focus-visible {
    color: var(--on-night);

    .name::after {
      transform: scaleX(1);
    }

    .arrow {
      transform: translate(2px, -2px);
    }
  }
`;
